export class DriverPenaltySettings
{
    Penalty: number = 0;
    OneTime: boolean = true;
    MinDuration: number = 0;
    Param: number = 0;
    constructor(data?: any)
    {
        if (data)
        {
            this.Penalty = data["penalty"];
            this.OneTime = <boolean>data["oneTime"];
            this.MinDuration = data["minDuration"];
            this.Param = data["param"];
        }
    }
}

export class DriverPenaltyViewModel/* implements IManagableObject*/ {
  //Id: number = 0;
  //Name: string;

    Overspeed: Array<DriverPenaltySettings>;

    Idling: DriverPenaltySettings;
    Lights: DriverPenaltySettings;
    SeatBelt: DriverPenaltySettings;
    DrivingWithoutRest: DriverPenaltySettings;

    HarshAccel: DriverPenaltySettings;
    HarshVAccel: DriverPenaltySettings;
    HarshBreak: DriverPenaltySettings;
    HarshTurn: DriverPenaltySettings;

    RatingDepth: number;
    GreenZone: number;
    YellowZone: number;

  init(data?: any)
  {
      if (data)
      {
          this.Overspeed = [];
          for (var i = 0; i < data["overspeed"].length; i++)
              this.Overspeed[i] = new DriverPenaltySettings(data["overspeed"][i]);
          while (this.Overspeed.length < 6)
              this.Overspeed.push(new DriverPenaltySettings());

          this.Idling = new DriverPenaltySettings(data["idling"]);
          this.Lights = new DriverPenaltySettings(data["lights"]);
          this.SeatBelt = new DriverPenaltySettings(data["seatBelt"]);
          this.DrivingWithoutRest = new DriverPenaltySettings(data["drivingWithoutRest"]);

          this.HarshAccel = new DriverPenaltySettings(data["harshAccel"]);
          this.HarshVAccel = new DriverPenaltySettings(data["harshVAccel"]);
          this.HarshBreak = new DriverPenaltySettings(data["harshBreak"]);
          this.HarshTurn = new DriverPenaltySettings(data["harshTurn"]);

          this.RatingDepth = data["ratingDepth"];
          this.GreenZone = data["greenZone"];
          this.YellowZone = data["yellowZone"];
      }
  }

  static fromJS(data: any): DriverPenaltyViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new DriverPenaltyViewModel();
    result.init(data);
    return result;
  }

  //IsChecked: boolean;
}
